export enum InsurerDeclarationSteps {
  'hideStep' = 0,
  'identificationInsuredStep' = 1,
  'claimFolderStep' = 2,
  'interventionStep' = 3,
  'summaryStep' = 4,
}
